A page of position openings for the given `hirerId`.

Currently, only position openings in the `global` and `globalPublicTest` schemes are returned.

A maximum of 20 position openings can be returned in a single page.
Additional position openings can be queried using a pagination cursor.
